module.exports = __webpack_public_path__ + "img/dcf71b5.png";